import { Section } from "components/Layout";
import { ModularLayout } from "layouts";
import React, { FC, PureComponent, PropsWithChildren } from "react";
import { Noop } from "utils/Noop";
import style from "./style.scss";
import { Button } from "@xapp/components";

export interface Profile {
    email?: string;
}

export interface VerificationPageProps {
    profile?: Profile;
    resendVerificationEmail(): void;
}

interface VerificationPageState {
}

export class VerificationPage extends PureComponent<VerificationPageProps, VerificationPageState> {

    static defaultProps: Partial<VerificationPageProps> = {
        resendVerificationEmail: Noop,
    };

    constructor(props: VerificationPageProps) {
        super(props);

        this.handleResendClicked = this.handleResendClicked.bind(this);
    }

    handleResendClicked() {
        const { resendVerificationEmail } = this.props;
        resendVerificationEmail();
    }

    render() {
        const { profile } = this.props;
        const email = (profile) ? profile.email : "the email address at this account";

        const message = `We sent a verification email to ${email}. Please open the email and follow the link.`;

        return (
            <ModularLayout>
                <Section>
                    <header className={style.head}>
                        <span className={style.icon}>📬</span>
                        <h1 className={style.title}>Check your inbox</h1>
                    </header>

                    <section className={style.msgSection}>
                        <p className={style.largeText}>To improve security for our users, we require all emails to be verified.</p>
                        <p className={style.largeText}>{message}</p>

                        <Button variation="primary" label="Request a new email" onClick={this.handleResendClicked} />

                        <p>The email was sent when you signed up. If you can't find it (make sure to check your SPAM folder) you can request a new one above.</p>
                    </section>

                    <footer className={style.footer}>
                        <p>If you have verified your email, you can <a href={`${window.location.origin}/`}> navigate home</a>. If you are still seeing this, you can <a target="_blank" rel="noopener noreferrer" href="https://help.xappmedia.com/">contact us!</a></p>
                    </footer>
                </Section>
            </ModularLayout>
        );
    }
}

export interface TextButtonProps {
    onClick(): void;
}

export const TextButton: FC<PropsWithChildren<TextButtonProps>> = (props) => (<button className={style.link} onClick={props.onClick}>{props.children}</button>);
